import { useBlocker } from '@tanstack/react-router';

type Props = {
  when: boolean;
  message: string;
};

export function NavigationPrompt({ when, message }: Props): null {
  useBlocker({
    shouldBlockFn: () => when && !window.confirm(message),
    disabled: !when,
  });

  return null;
}
